import React, { useEffect, useState } from 'react';
import '../../App.css';
import { useAccount } from 'wagmi';
import rocketImg from '../../assets/images/rocket.png';
import { backendApiUrlBase } from '../../constants/global';

function Discover() {

  const viewDetailsbuttonVal = "Provide Liquidity --->"
  let exchangeList = ['FusionX', 'AGNI', 'ApertureSwap', 'iZiSwap'];
  const [exchnageDetailList, setExchnageDetailList] = useState<any>([]);
  const { address, isConnected } = useAccount();
  const [isDataLoadng, setIsDataLoadng] = useState(false);
  const [portfolio, setPortfolio] = useState(""); //need to check logic
  const [totalVault, setTotalVault] = useState(0); //will get this value from backend api
  const [totalTvlInUsd, setTotalTvlInUsd] = useState(""); //will get this value from backend api

  useEffect(() => {
    getExchangeDetails();
  }, []);

  const getExchangeDetails = async () => {
    const data = await fetch(`${backendApiUrlBase}vaults/stats`);
    let jsonData = await data.json();
    console.log("jsonData", jsonData);

    let totalUsd = 0;
    let totalVault = 0;

    jsonData = jsonData.map((e: any) => {
      totalVault = totalVault + e.totalVaults;
      totalUsd = totalUsd + e.tvlUSD;
      if (e?.dex === "FusionX") {
        e.exchangeImage = "/img/fusionNewDEX.svg";
      } else if (e?.dex === "Agni") {
        e.exchangeImage = "/img/agniNewDEX.svg";
      } else if (e?.dex === "ApertureSwap") {
        e.exchangeImage = "/img/apertureNewDEX.svg";
      } else if (e?.dex === "Swapsicle") {
        e.exchangeImage = "/img/swapsicleNewDEX.svg";
      }
      else if (e?.dex === "Uniswap") {
        e.exchangeImage = "/img/uniSwapNewDEX.svg";
      }
      return e;
    }).sort((a: { tvlUSD: number; }, b: { tvlUSD: number; }) => b.tvlUSD - a.tvlUSD);

    setTotalTvlInUsd(totalUsd.toString());
    setTotalVault(totalVault);

    setExchnageDetailList(jsonData);
  }

  const getTwoDecimal = (num: any) => {
    const roundedNum = Math.floor(num * 100) / 100;
    return roundedNum.toFixed(2);
  }

  const getFormatedData = (x: any) => {
    if (isNaN(x)) return x;

    if (x < 999) {
      return getTwoDecimal(x);
    }

    if (x < 1000) {
      return getTwoDecimal(x);
    }

    if (x < 10000) {
      return getTwoDecimal(x / 1000) + "K";
    }

    if (x < 100000) {
      return getTwoDecimal(x / 1000) + "K";
    }

    if (x < 1000000) {
      return getTwoDecimal(x / 1000) + "K";
    }

    if (x < 10000000) {
      return getTwoDecimal(x / 1000000) + "M";
    }

    if (x < 1000000000) {
      return getTwoDecimal(x / 1000000) + "M";
    }

    if (x < 1000000000000) {
      return getTwoDecimal(x / 1000000000) + "B";
    }

    return "1T+";
  }

  return (
    <>
      <div className='custom-container'>
        <div className='second_section row mt-5 mb-5'>
          <h4 className="valut_header  redHatFont fnt_wgt_600">Browse Exchanges</h4>
          {exchnageDetailList.map((e: any, index: any) => {
            return <div className='card_wdth_50' key={index}>
              <div className='pddng_15 over_hidden  mb-3  outer_section'>
                <div className='dsp_start exchng_mrgn '>
                  <div>
                    <div className='mb-4 first_sec_heder1'>{e.dex}</div>
                    <div className='flex-exchng'>
                      <div className='mr_35'>TVL <br /> <span className='fnt_wgt_800 secondary_color'>${getFormatedData(e.tvlUSD)}</span></div>
                      <div>Total Pairs <br /> <span className='fnt_wgt_800 '>{e.totalVaults}</span></div>
                    </div>
                  </div>
                  <div className='dex_img_margn' style={{ height: '16rem' }}>
                    <img
                      alt='dex img'
                      src={e.exchangeImage}
                      className='dex-image hgt_10'
                      onError={(e) => {
                        (e.target as HTMLImageElement).src = rocketImg;
                      }}
                    />
                  </div>
                </div>
                <div className="dsp_around mb-2  mt-4 ">
                  <div className="wdth_100 ">
                    <a className="btn btn-riv-secondary view_btn_wdth" href={`#/discover/${e.dex}/${e.chain}`}>
                      {viewDetailsbuttonVal}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          })}
        </div>
      </div>
    </>
  );
}

export default Discover;
